const defaultOptions = {
  hasNetProfitPercentage: false,
  hasTurnover: true,
  maxPeriod: 120,
};

export const sharedCriteriaFields = (options) => {
  const { hasNetProfitPercentage, hasTurnover, maxPeriod } = {
    ...defaultOptions,
    ...options,
  };

  return [
    {
      columns: 12,
      fields: [
        {
          columns: 12,
          field: 'governmentBacked',
          type: 'boolean',
        },
      ],
      label: 'Can you offer this product as part of an accredited government backed scheme',
      noBorder: true,
    },
    {
      field: 'amount',
      fields: [
        {
          field: 'greaterThan',
          label: 'From',
          type: 'currency',
        },
        {
          field: 'lowerThan',
          label: 'To',
          type: 'currency',
        },
      ],
      label: 'Minimum and maximum facility',
    },
    {
      fields: [
        {
          field: 'period',
          columns: 12,
          max: maxPeriod,
          min: 0,
          rightElement: `${maxPeriod} MONTHS`,
          label: '0 MONTHS',
          type: 'range',
          values: ['greaterThan', 'lowerThan'],
        },
      ],
      label: 'Minimum and maximum facility term',
    },
    ...(!hasTurnover
      ? []
      : [
          {
            field: 'revenue',
            fields: [
              {
                field: 'greaterThan',
                label: 'From',
                type: 'currency',
              },
              {
                field: 'lowerThan',
                label: 'To',
                type: 'currency',
              },
            ],
            label: 'Minimum and maximum business annual turnover',
          },
        ]),
    {
      columns: hasTurnover ? 6 : 12,
      fields: [
        {
          field: 'tradingPeriod',
          columns: hasTurnover ? 12 : 6,
          rightElement: '120 MONTHS',
          label: '0 MONTHS',
          max: 120,
          min: 0,
          type: 'slider',
        },
      ],
      label: 'Minimum business months trading',
    },
    ...(!hasNetProfitPercentage
      ? []
      : [
          {
            columns: 12,
            fields: [
              {
                columns: 6,
                field: 'netProfitPercentage',
                type: 'mask',
                options: {
                  delimiter: '',
                  numeral: true,
                  numeralDecimalMark: '.',
                  prefix: '% ',
                  rawValueTrimPrefix: true,
                },
              },
            ],
            label: 'Minimum net profit',
          },
        ]),
    {
      columns: 12,
      fields: [
        {
          columns: 12,
          field: 'sector',
          optionsColumns: 3,
          type: 'multiple',
        },
      ],
      label: 'Business sectors',
    },
    {
      fields: [
        {
          columns: 12,
          field: 'companyType',
          optionsColumns: 6,
          type: 'multiple',
        },
      ],
      label: 'Company types',
    },
    {
      fields: [
        {
          columns: 12,
          field: 'creditworthiness',
          optionsColumns: 4,
          type: 'multiple',
        },
      ],
      label: 'Credit worthiness risk of businesses',
    },
  ];
};

export const sharedFeesFields = (hasPeriodocity, hasFees = true) => [
  ...(!hasPeriodocity
    ? []
    : [
        {
          columns: 12,
          fields: [
            {
              field: 'periodicity',
              columns: 3,
              type: 'select',
            },
          ],
          label: 'Select frequency',
        },
      ]),
  ...(!hasFees
    ? []
    : [
        {
          columns: 12,
          field: 'serviceFees',
          fields: [
            {
              columns: 3,
              field: 'minimumFee',
              label: 'From',
              type: 'mask',
              options: {
                delimiter: '',
                numeral: true,
                numeralDecimalMark: '.',
                prefix: '% ',
                rawValueTrimPrefix: true,
              },
            },
            {
              columns: 3,
              field: 'maximumFee',
              label: 'To',
              prefix: '%',
              type: 'mask',
              options: {
                delimiter: '',
                numeral: true,
                numeralDecimalMark: '.',
                prefix: '% ',
                rawValueTrimPrefix: true,
              },
            },
          ],
          label: 'Service fee',
        },
      ]),
  {
    columns: 4,
    fields: [
      {
        columns: 12,
        field: 'entryFees',
        type: 'boolean',
      },
    ],
    label: 'Arrangement Fee',
  },
  {
    columns: 4,
    fields: [
      {
        columns: 12,
        field: 'earlyRepaymentFees',
        type: 'boolean',
      },
    ],
    label: 'Early Repayment fee ',
  },
  {
    columns: 4,
    fields: [
      {
        columns: 12,
        field: 'exitFees',
        type: 'boolean',
      },
    ],
    label: 'Exit Fee',
  },
];
